import { createApplicationApi } from '@/modules/service-desk/shared/application-api';
import { runServiceDeskWorkflow } from '@/modules/service-desk/shared/application-workflows';
import { BusinessCardApplyValues } from '../schemas/business-card-apply-form-schema';
import { BusinessCardApplication, BusinessCardStatus } from '../types/business-card.types';
import { BUSINESS_CARD_FIELDS } from '../graphql/business-card.fields';

export const businessCardApi = createApplicationApi<BusinessCardApplication>(
  'BusinessCardApplication',
  BUSINESS_CARD_FIELDS,
  { deliveredLast: true }
);

interface SubmitBusinessCardParams {
  existing?: BusinessCardApplication;
  values: BusinessCardApplyValues;
}

/**
 * Legacy `CreateBusinessCardApplicationCommand`, now the BUSINESS_CARD_APPLICATION_SUBMIT workflow: it
 * refuses interns and employees on probation (creating only) and lets the applicant edit only while
 * Pending. The applicant, department and status come from the session, never from here.
 */
export const submitBusinessCardApplication = ({ existing, values }: SubmitBusinessCardParams) =>
  runServiceDeskWorkflow('BUSINESS_CARD_APPLICATION_SUBMIT', {
    itemId: existing?.ItemId,
    name: values.name.trim(),
    designation: values.designation.trim(),
    email: values.email.trim(),
    mobileNumber: values.mobileNumber.trim(),
  });

interface ChangeBusinessCardStatusParams {
  itemId: string;
  status: BusinessCardStatus;
}

/** Legacy `UpdateBusinessCardApplicationStatusCommand` (BUSINESS_CARD_APPLICATION_STATUS workflow). */
export const changeBusinessCardStatus = ({ itemId, status }: ChangeBusinessCardStatusParams) =>
  runServiceDeskWorkflow('BUSINESS_CARD_APPLICATION_STATUS', { itemId, status });
